import { render } from "./ContentWeekly.vue?vue&type=template&id=1862462a"
import script from "./ContentWeekly.vue?vue&type=script&lang=js"
export * from "./ContentWeekly.vue?vue&type=script&lang=js"

import "./ContentWeekly.vue?vue&type=style&index=0&id=1862462a&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__